//src/pages/admin/components/MediaPickerModal.jsx

import React from 'react';
import { AdminAPI } from '../../../api/admin';
import { Card, Actions, Btn, Field, Badge } from '../ui';

export default function MediaPickerModal({ open, onClose, onPick, multi = true }) {
  const [items, setItems] = React.useState([]);
  const [page, setPage] = React.useState(1);
  const [pageSize] = React.useState(24);
  const [total, setTotal] = React.useState(0);
  const [q, setQ] = React.useState('');
  const [onlyImages] = React.useState(true);
  const [busy, setBusy] = React.useState(false);
  const [sel, setSel] = React.useState(new Set());

  const load = React.useCallback(async ()=>{
    if (!open) return;
    setBusy(true);
    try{
      const resp = await AdminAPI.listMediaLibrary({
        page, page_size: pageSize, q: q || undefined,
        mime: onlyImages ? 'image/*' : undefined,
      });
      const list = resp?.media || [];
      setItems(list);
      setTotal(resp?.pagination?.total ?? list.length);
    } finally { setBusy(false); }
  }, [open, page, pageSize, q, onlyImages]);

  React.useEffect(()=>{ setPage(1); }, [q]);
  React.useEffect(()=>{ load(); }, [load]);

  if (!open) return null;

  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const toggle = (id) => {
    setSel(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else {
        if (!multi) next.clear();
        next.add(id);
      }
      return next;
    });
  };

  const pick = () => {
    const selected = items.filter(it => sel.has(it.id));
    if (!selected.length) return;
    onPick(selected);
    onClose?.();
  };

  return (
    <div style={backdrop}>
      <div style={modal}>
        <Card>
          <h3>Медиафайлы</h3>
          <div style={{display:'flex', gap:10, alignItems:'center', marginBottom:8}}>
            <Field>Поиск
              <input value={q} onChange={e=>setQ(e.target.value)} placeholder="Имя / подпись…" />
            </Field>
            <Badge>Всего: <b>{total}</b></Badge>
          </div>

          <div style={grid}>
            {busy && <div>Загрузка…</div>}
            {!busy && items.map(m => {
              const url = m.thumbnail_url || m.url;
              const active = sel.has(m.id);
              return (
                <button
                  key={m.id}
                  onClick={()=>toggle(m.id)}
                  style={{...tile, outline: active ? '2px solid var(--primary)' : '1px solid #ddd'}}
                  title={m.original_filename || m.filename}
                >
                  {url ? <img src={url} alt="" style={img} /> : <div style={empty}>no preview</div>}
                  <div style={meta}>
                    <small>#{m.id}</small>
                    <div style={{whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>
                      {m.original_filename || m.filename}
                    </div>
                  </div>
                </button>
              );
            })}
          </div>

          <Actions style={{marginTop:10, justifyContent:'space-between'}}>
            <div>
              <Btn disabled={page<=1} onClick={()=>setPage(p=>p-1)}>‹ Назад</Btn>{' '}
              <Btn disabled={page>=totalPages} onClick={()=>setPage(p=>p+1)}>Вперёд ›</Btn>{' '}
              <Badge>{page} / {totalPages}</Badge>
            </div>
            <div>
              <Btn onClick={onClose}>Отмена</Btn>{' '}
              <Btn $kind="primary" onClick={pick} disabled={!sel.size}>Добавить выбранные</Btn>
            </div>
          </Actions>
        </Card>
      </div>
    </div>
  );
}

const backdrop = { position:'fixed', inset:0, background:'rgba(0,0,0,.35)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center' };
const modal = { width:'min(1100px, 96vw)', maxHeight:'92vh', overflow:'auto' };
const grid = { display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))', gap:10 };
const tile = { display:'flex', flexDirection:'column', gap:6, borderRadius:10, padding:6, background:'#fff', cursor:'pointer' };
const img  = { width:'100%', height:120, objectFit:'cover', borderRadius:8, background:'#f5f5f5' };
const empty = { display:'grid', placeItems:'center', width:'100%', height:120, background:'#f3f3f3', borderRadius:8, color:'#888' };
const meta = { fontSize:12, color:'#666' };
